import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import ThemeTagRounded from 'assets/components/tag/themes/Theme.Tag.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import Theme from 'assets/themes/Theme.Common';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { DealerAction, useDealerProvider } from '../Dealer.Hooks';

export default function DealerList() {
  const { lang } = getLocales();
  const { listApi, pageRouter } = useDealerProvider();
  const { permissions } = useAuthStore();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-user-friends" />}
      header={lang.dealers}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th data-actions></th>
          <th>{lang.name}</th>
          <th>{lang.representative}</th>
          <th>{lang.group}</th>
          <th>{lang.products}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: dealer }) => (
            <tr key={dealer.id}>
              <td>
                <Box
                  class={ThemeTagRounded}
                  style={
                    dealer?.isInactive
                      ? { color: Theme.Color.error, backgroundColor: Theme.Color.errorLight }
                      : { color: Theme.Color.success, backgroundColor: Theme.Color.successLight }
                  }
                >
                  <Icon class={dealer.isInactive ? 'fas-ban' : 'fas-check'} />
                  &nbsp; {dealer.isInactive ? lang.inactive : lang.active}
                </Box>
              </td>
              <td>
                <b>{dealer.name}</b>
              </td>
              <td>{dealer.representative?.name}</td>
              <td>{dealer.dealerGroup?.name}</td>
              <td>
                {dealer.products
                  ?.filter((p) => p.isActive)
                  ?.map((p) => p.name)
                  ?.join(', ')}
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <DropdownButton
                    buttonMedia={<Icon class="fas-download" />}
                    horizontalPosition="auto_fixed"
                    verticalPosition="auto_fixed"
                    subcomponents={ThemeDropdownButtonPopup}
                    disabled={!dealer.mediaFiles?.length}
                    active
                    htmlElementProps={{ title: lang.download }}
                    dropdownOptions={
                      <DataMap
                        data={dealer.mediaFiles}
                        render={({ data: doc }) => (
                          <Button
                            key={doc.id}
                            class={ThemeButtonMenuItem}
                            style={{ buttonText: { textTransform: 'unset' } }}
                            url={doc.url}
                            media={<Icon class="fas-download" />}
                            target="_blank"
                            children={doc.name}
                          />
                        )}
                      />
                    }
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: dealer.id.toString(),
                      action: DealerAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_DEALER}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: dealer.id.toString(),
                      action: DealerAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_DEALER}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
